const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN
const IMAGE_HOST = process.env.NEXT_PUBLIC_API_IMAGE_URL

export default function PostMicroSeoMarkup(props) {
    const {post, category} = props

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: `
        { 
          "@context": "https://schema.org", 
            "@type": "Article",
            "headline": "${post.name.replace(/"/g, '\\"')}",
            "image": "${IMAGE_HOST}${post.bigImage?.fileUrl}",
            "genre": "${category.name}", 
            "keywords": "${category.name}", 
            "author": {
              "name": "Wayout Fitness"
            },
            "url": "${DOMAIN}/food/calories/${post.urlKey}",
              "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://google.com/article"
            },
            "datePublished": "${post.createdAt.split('T')[0]}",
            "dateCreated": "${post.createdAt.split('T')[0]}",
            "dateModified": "${post.updatedAt.split('T')[0]}",
            "description": "${post.contentShort?.replace(/<[^>]+>/g, '').replace(/"/g, '\\"')}"
        }`
            }
            }
        />
    )
}
